import { render } from "./versionControl.vue?vue&type=template&id=9c28e1e4&scoped=true"
import script from "./versionControl.vue?vue&type=script&lang=js"
export * from "./versionControl.vue?vue&type=script&lang=js"

import "./versionControl.vue?vue&type=style&index=0&id=9c28e1e4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c28e1e4"]])

export default __exports__